module.exports = __webpack_public_path__ + "img/technology.a38a0918.svg";